import {Injectable, signal, WritableSignal} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {routeHome} from '../constants/routing.constants';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {

  home: MenuItem = {routerLink: routeHome(), icon: 'pi pi-home'};

  breadcrumbs: WritableSignal<MenuItem[] | undefined> = signal(undefined);
  clear(): void {
    this.breadcrumbs.set([this.home]);
  }
  reset(): void {
    this.breadcrumbs.set(undefined);
  }
  updateBreadcrumbs(newValue: MenuItem[]): void {
    const breadcrumbs: MenuItem[] = [];
    breadcrumbs.push(this.home);
    newValue.forEach((item: MenuItem): number => breadcrumbs.push(item));
    this.breadcrumbs.set(breadcrumbs);
  }

}
